import { injectable } from 'inversify';
import { Vue } from 'vue-property-decorator';
import { queryElements, replaceWithElement } from '@/app/shared/utils/content-utils';
import * as Api from "@/app/interaction/api";
import { ClickImageItem, ClickImageContent, ClickImageState } from './click-image-interfaces';
import { createInteractionComponent } from '@/app/interaction/ui'

@injectable()
export class IncludeClickImageHandler implements Api.IncludeComponentsHandlerInterface {

  public async includeComponents($parsedContent: any): Promise<Vue[]> {
    const elements: any = queryElements('.clickimage.component', $parsedContent);
    if (elements === null) {
      return [];
    }

    let components = []
    for (const element of elements) {
      const $element: any = $(element);
      const component = this.includeComponent($element);
      components.push(component)
    }

    return components
  }

  private includeComponent($element: any): Vue {
    const id: string = $element.attr('id');
    const title: string|null = $('.clickimage__title', $element).text() || null;
    const instruction: string|null = $('.clickimage__instruction', $element).html() || null;
    const items: ClickImageItem[] = this.getItems($('.clickimage__item', $element));
    
    const interactionComponent = createInteractionComponent<ClickImageContent, ClickImageState>(id, 'click-image', {
      title,
      instruction
    }, {
      items
    })

    interactionComponent.$mount();

    replaceWithElement(`#${id}`, interactionComponent.$el);

    return interactionComponent
  }

  private getItems($items: any): ClickImageItem[] {
    let items: ClickImageItem[] = [];
    $items.each((i: number, item: any) => {
      const $item = $(item);
      items = [...items, {
        imageUri: $('.clickimage__item-image', $item).attr('src') as string,
        title: $('.clickimage__item-title', $item).html() || null,
        content: $('.clickimage__item-content', $item).html()
      }];
    });

    return items;
  }
}
